<script setup lang="ts">
import {
  ScheduleDependOnResult,
  createTask,
  deferred
} from "@zyzgroup/core-common";
import { TWEEN, type InterpolationFunction } from "@zyzgroup/core-web";
import InterpolationGraphDisplay from "./InterpolationGraphDisplay.vue";

// for merge ce shadow-root styles
defineOptions({
  customOptions: { InterpolationGraphDisplay },
  inheritAttrs: true
});

const defaultEaseDuration = 2000;

const props = withDefaults(
  defineProps<{
    interpolationList?: {
      interpolationName: string;
      interpolationFunction: InterpolationFunction;
      easeDuration?: number;
    }[];
  }>(),
  {
    interpolationList: () => [
      {
        interpolationName: "Linear",
        interpolationFunction: TWEEN.Interpolation.Linear
      },
      {
        interpolationName: "Bezier",
        interpolationFunction: TWEEN.Interpolation.Bezier
      },
      {
        interpolationName: "CatmullRom",
        interpolationFunction: TWEEN.Interpolation.CatmullRom
      }
    ]
  }
);

const emits = defineEmits<{
  // (event: "click"): void;
}>();

const children: Record<string, any> = {};
function setChild(el: any, interpolationName: string) {
  if (el) {
    children[interpolationName] = { el, defer: deferred() };
  }
}

// 初次加载全部执行一遍
const schedule = new ScheduleDependOnResult({ concurrency: 1 });
function onMount(interpolationName: string) {
  schedule.asap(
    createTask({
      fn: () => {
        children[interpolationName].el.start();
        return children[interpolationName].defer.promise;
      }
    })
  );
}

function onComplete(interpolationName: string) {
  const child = children[interpolationName];
  if (child) {
    child.defer.resolve();
    delete children[interpolationName];
  }
}

defineExpose({});
</script>

<template>
  <div>
    <template
      v-for="interpolation in props.interpolationList"
      :key="interpolation.interpolationName"
    >
      <div class="interpolation-graph-display-wrap">
        <InterpolationGraphDisplay
          :interpolationName="interpolation.interpolationName"
          :interpolationFunction="interpolation.interpolationFunction"
          :easeDuration="interpolation.easeDuration || defaultEaseDuration"
          @mount="onMount"
          @complete="onComplete"
          :ref="(el) => setChild(el, interpolation.interpolationName)"
        />
      </div>
    </template>
  </div>
</template>

<!--
  ce 中不要使用v-bind
  color: v-bind(fontColor);
-->
<style scoped>
.interpolation-graph-display-wrap {
  display: inline-block;
  margin-right: 10px;
}
</style>
